var _rect, _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoYoutubeNotConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2286 10.3338C27.0931 9.83437 26.8288 9.37907 26.4619 9.01323C26.0951 8.64739 25.6385 8.38377 25.1377 8.24863C23.3044 7.75 15.9255 7.75 15.9255 7.75C15.9255 7.75 8.54673 7.76511 6.71338 8.26374C6.21259 8.39888 5.75603 8.6625 5.38918 9.02834C5.02233 9.39418 4.75798 9.84948 4.62247 10.3489C4.06792 13.5975 3.85277 18.5475 4.63762 21.6662C4.77313 22.1656 5.03748 22.6209 5.40433 22.9868C5.77118 23.3526 6.22774 23.6162 6.72854 23.7514C8.56188 24.25 15.9407 24.25 15.9407 24.25C15.9407 24.25 23.3195 24.25 25.1529 23.7514C25.6537 23.6162 26.1102 23.3526 26.4771 22.9868C26.8439 22.6209 27.1083 22.1656 27.2438 21.6662C27.8286 18.413 28.0089 13.4661 27.2286 10.3338Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.577 19.5353L19.6983 15.9996L13.577 12.4639V19.5353Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.0703,
    r: 6,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.0703C22.2385 30.0703 20 27.8318 20 25.0703C20 22.3088 22.2385 20.0703 25 20.0703C27.7615 20.0703 30 22.3088 30 25.0703C30 27.8318 27.7615 30.0703 25 30.0703ZM25 24.3633L23.586 22.9488L22.8785 23.6563L24.293 25.0703L22.8785 26.4843L23.586 27.1918L25 25.7773L26.414 27.1918L27.1215 26.4843L25.707 25.0703L27.1215 23.6563L26.414 22.9488L25 24.3633Z",
    fill: "#FF6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutubeNotConnected);
export default __webpack_public_path__ + "static/media/logo_youtube_not_connected.cc1fdbcd7e6a8d7680ac7ecd565fc7c8.svg";
export { ForwardRef as ReactComponent };